import docFlowApi from '@/api/eDocInternal/docFlow'
// import idApi from '@/api/esign/identification'
import { docFlowModule, workflowModule, commonComponentModule, globalModule } from '@/store/moduleName'
import messageUtil from '@/utils/messageUtil'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import { mapState, mapGetters } from 'vuex'
// import signHelper from '@/helper/signHelper'
import { DOC_FLOW_STATUS } from '@/constant/constant'
import arrayUtil from '@/utils/arrayUtil'
// import CryptoUtil from '@/lib/g2e/CryptoUtil.js'
// import jwtTokenApi from '@/api/general/jwtToken'
import { parseJwt } from '@/utils/utils'
import { getStorage } from '@/utils/storageUtil'

export const docFlowMethod = {
  data: function () {
    return {
      // openerList: [],
      newOpenersEuid: [],
      newOpenersObj: [] // for checking opener's public key is generated or not
      // filterText: '',
      // pageNum: 1,
      // pageSize: 10,
      // orderingProp: EDOC_SORT_PROP.RECEIVE_DATE
      // onlyShowSuggestAndReceiver: false,
      // genPdfBtnLoading: false
    }
  },
  computed: {
    ...mapState(docFlowModule, {
      listLoading: state => state.listLoading,
      openerList: state => state.openerList
    }),
    ...mapGetters(commonComponentModule, ['decryptedFileKey', 'encryptedFileKey']),

    onlyShowPrefilled: {
      get () {
        return this.$store.state[docFlowModule].onlyShowPrefilled
      },
      set (val) {
        this.$store.commit(docFlowModule + '/setFilterText', '')
        this.$store.commit(docFlowModule + '/setOnlyShowPrefilled', val)
        this.getProcessList(val, null, this.status)
      }
    },
    filterText: {
      get () {
        return this.$store.state[docFlowModule].filterText
      },
      set (val) {
        this.$store.commit(docFlowModule + '/setOnlyShowPrefilled', false)
        this.$store.commit(docFlowModule + '/setFilterText', val)
        this.getProcessList(false, val, this.status)
      }
    },
    pageNum: {
      get () {
        return this.$store.state[docFlowModule].pageNum
      },
      set (val) {
        this.$store.commit(docFlowModule + '/setPageNum', val)
      }
    },
    pageSize: {
      get () {
        return this.$store.state[docFlowModule].pageSize
      },
      set (val) {
        this.$store.commit(docFlowModule + '/setPageNum', val)
      }
    },
    orderingProp: {
      get () {
        return this.$store.state[docFlowModule].orderingProp
      },
      set (val) {
        this.$store.commit(docFlowModule + '/setOrderingProp', val)
        this.getProcessList(this.onlyShowPrefilled, this.filterText, this.status)
      }
    },
    isMeOpener () {
      return this.openerList.some(opener =>
        opener.euid === parseJwt(getStorage('g2e-jwt-token')).euid
      )
    }
  },
  watch: {
    newOpenersObj: {
      handler: async function (val) {
        this.loading = true
        await this.checkAndShowNoKeyPairUser(val)
        this.loading = false
      }
    },
    deep: true
    // orderingProp: function (val) {
    //   this.getProcessList(this.onlyShowPrefilled, this.filterText, this.status)
    // }
  },
  methods: {
    // handleMaskAsCompleteDialog: function (val, index) {
    //   this.$set(this.maskAsCompleteDialog, [index], val)
    // },

    // handleSendToNextCard: function (val, index) {
    //   this.$set(this.isShowSendToNextCard, [index], val)
    // },

    // handleFullHistoryDialog: function (val, index) {
    //   this.$set(this.fullHistoryDialog, [index], val)
    // },

    async refreshTaskListCount () {
      await this.$store.dispatch(workflowModule + '/countBwItems')
      this.$store.dispatch(workflowModule + '/countPersonalItems')
      this.$store.dispatch(workflowModule + '/countGroupItems')
      this.$store.dispatch(workflowModule + '/countAttentionItems')
    },

    getAncestorProcess (processId, inflowStatus) {
      docFlowApi.getAncestorProcess(processId, inflowStatus, resp => {
        this.ancestorProcess = resp.data.reverse() // descending order
      })
    },

    async getProcessList (onlyShowPrefilled, filterText, docFlowStatus) {
      if (typeof onlyShowPrefilled === 'undefined') {
        onlyShowPrefilled = false
      }
      if (typeof filterText === 'undefined') {
        filterText = null
      }
      if (typeof docFlowStatus === 'undefined') {
        docFlowStatus = [DOC_FLOW_STATUS.WAITING]
      }
      await this.$store.dispatch(docFlowModule + '/getProcessList', { 'pageNum': this.pageNum, 'status': docFlowStatus, 'keyword': filterText, 'orderByKey': this.orderingProp, 'isContainPrefilledReceiverOnly': onlyShowPrefilled, 'pageSize': this.pageSize, 'isContainPrefilledInsOnly': onlyShowPrefilled })
    },

    /* getInstructionPdf (processId, inflowStatus) {
      this.genPdfBtnLoading = true

      docFlowApi.getInstructionPdf(processId, inflowStatus, resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          let disposition = resp.headers['content-disposition']
          let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          link.setAttribute('download', filename)
          link.click()
          window.URL.revokeObjectURL(url)
        }
        this.genPdfBtnLoading = false
      })
    },

    genInstructionPdfAndBuildIdLink (processId, inflowStatus, redirectPath) {
      this.genPdfBtnLoading = true
      let finalForm = {
        inflowStatusCodes: inflowStatus,
        processId: processId,
        redirectUrl: ID_SIGN_AND_DOWNLOAD_PDF_CB_URL
      }
      let signObj = {}
      signObj[signHelper.GET_SIGN_LINK_URL] = docFlowApi.genInstructionPdfAndBuildIdLinkUrl
      signObj[signHelper.SIGN_AND_START_WORKFLOW_URL] = idApi.extSignUrl
      signObj[signHelper.REDIRECT_PATH] = redirectPath
      signObj[signHelper.POST_FORM] = finalForm
      signObj[signHelper.SUCCESS_MSG_KEY] = 'TrainingClient.SaveSuccess'
      signObj[signHelper.FAIL_MSG_KEY] = 'TaskList.eSign.FailMessage'

      signHelper.signAndDownloadPdf(signObj)
      setTimeout(() => {
        this.genPdfBtnLoading = false
      }, 10000) // waiting for 10 seconds
    },
    */

    buildStaffList (staffList) {
      let result = []
      if (!arrayUtil.isArrayEmptyOrNull(staffList)) {
        staffList.forEach(obj => {
          result.push({
            euid: obj.euid,
            gid: obj.definedGroupId
          // chinName: obj.chinName,
          // portName: obj.portName,
          // chinGroupName: obj.chinGroupName,
          // portGroupName: obj.portGroupName,
          // subunitAbbr: obj.subunitAbbr,
          // subunitChinName: obj.subunitChinName,
          // subunitId: obj.subunitId,
          // subunitPortName: obj.subunitPortName
          })
        })
      }

      return result
    },

    searchIconClick (isShow) {
      if (typeof this.showBatchModeBox !== 'undefined') {
        this.showBatchModeBox = false
      }
      this.$store.commit(docFlowModule + '/setOnlyShowPrefilled', false)
      this.$store.commit(docFlowModule + '/setFilterText', '')
      this.$store.commit(docFlowModule + '/setPageNum', 1)
      this.showBatchModeBox = !isShow
      this.getProcessList(this.onlyShowPrefilled, '', this.status)
      if (isShow) {
        this.$refs.filterBox.focus()
      }
    },

    search (val) {
      this.$store.commit(docFlowModule + '/setFilterText', val)
      this.handlePageChange(1)
    },

    async transferProcessToStaff (processId, event, successCb) {
      let form = {
        senderNote: event.senderNote,
        dfProcessId: processId,
        receiverTOList: this.buildStaffList(event.nextStaffObj),
        preFilledReceiverTOList: this.buildStaffList(event.preFilledReceiver),
        prefilledInstruction: event.prefilledInstruction,
        processAttachmentList: event.processAttachmentList,
        oriStatusCode: event.oriStatusCode
      }

      let cb = resp => {
        if (resp.status === 201 || resp.status === 200) {
          // this.getProcessList()
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          if (successCb) {
            successCb()
          }
        }
        this.transferLoading = false
      }
      await docFlowApi.redirectProcess(form, cb)
    },

    previewFileList (processId, showDialog = true) {
      let docCode = null // encrypted file
      docFlowApi.getDocumentAttachmentList(processId, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.files = []
          let respData = resp.data
          // respData.sort(getArraySorter('listOrder', true))
          for (let i = 0; i < respData.length; i++) {
            let e = respData[i]
            let pdfInitParams = {
              url: docFlowApi.downloadDocumentUrl + '?docCode=' + e.docCode + '&processId=' + processId,
              httpHeaders: { Authorization: 'Bearer ' + this.$g2eOauth.token },
              withCredentials: true,
              CMapReaderFactory
            }
            e.displayName = e.docName.substring(0, e.docName.lastIndexOf('.'))
            e.fileExtension = e.docName.substring(e.docName.lastIndexOf('.') + 1)

            // cannot apply e.docType === DOC_FLOW_FILE_TYPE.OFICIO, always judge as false
            if (e.docType === 'DM') {
              // e.docTypeI18nCode = 'Outbox.Oficio'   // no need to show
              e.docTypeI18nCode = null
            } else if (e.docType === 'DA') {
              if (e.fileExtension === 'encrypted') {
                docCode = e.docCode
              }
              // e.docTypeI18nCode = 'Outbox.Attachment'   // no need to show
              e.docTypeI18nCode = null
            } else if (e.docType === 'PA') {
              e.docTypeI18nCode = 'Outbox.RefDoc'
            }
            // console.log(i + ' || ' + e.displayName + ' ||  ' + e.fileExtension)
            e.url = pdfInitParams
            this.files.push(e)
          }
          if (showDialog) {
            this.dialog = true
          }
        } else {
          messageUtil.httpStatusHandler(resp, this)
        }

        if (docCode) {
          if (this.isMeOpener) {
            this.getDFDocumentKey(processId, docCode)
          } else {
            this.$store.commit(commonComponentModule + '/clearSecurityFileKeys')
            this.$store.commit(commonComponentModule + '/setKeyPairId', -1)
          }
        }
      })
    },

    showReceiverOrGroupName (staff) {
      if (staff.chinName || staff.portName) {
        return this.$chPtObjData('chinName', staff)
      } else if (staff.chinGroupName || staff.portGroupName) {
        return this.$chPtObjData('chinGroupName', staff)
      } else if (staff.chinReceiverName || staff.portReceiverName) {
        return this.$chPtObjData('chinReceiverName', staff)
      } else if (staff.chinReceiverGroupName || staff.portReceiverGroupName) {
        return this.$chPtObjData('chinReceiverGroupName', staff)
      }
    },

    // showing pre grouped receivers or groups
    showGroupedReceiverAndGroupName (staff) {
      if ((staff.chinGroupedReceiverName || staff.portGroupedReceiverName) && (staff.chinGroupedReceiverGroupName || staff.portGroupedReceiverGroupName)) {
        return this.$chPtObjData('chinGroupedReceiverName', staff) + ', ' + this.$chPtObjData('chinGroupedReceiverGroupName', staff)
      } else if (staff.chinGroupedReceiverName || staff.portGroupedReceiverName) {
        return this.$chPtObjData('chinGroupedReceiverName', staff)
      } else {
        return this.$chPtObjData('chinGroupedReceiverGroupName', staff)
      }
    },

    showSenderOrGroupName (staff) {
      if (staff.chinSenderName || staff.portSenderName) {
        return this.$chPtObjData('chinSenderName', staff)
      } else {
        // return this.$chPtObjData('chinSendFromGroupName', staff) // backend didn't implement this field
      }
    },

    showSenderEuidOrGroupAbbr (item) {
      if (item.senderEuid) {
        return item.senderEuid
      } else {
        // backend didn't implement this field
      }
    },

    // Many pages use below function
    updateDetail: function (index) {
      this.detailPageObj = this.processData.records[index]
      this.isListMode = false
    },

    async downloadBatchDocument (processId) {
      console.log('downloadBatchDocument : ' + processId)
      let docList = []
      this.downloadBatchDocLoading = true
      await docFlowApi.getDocumentAttachmentList(processId, resp => {
        docList = resp.data
      })
      docFlowApi.downloadBatchDocument(processId, docList, resp => {
        if (resp.status === 200 || resp.status === 201) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          // let disposition = resp.headers['content-disposition']
          // let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          // link.setAttribute('download', filename)
          link.setAttribute('download', 'document.zip')
          link.click()
          window.URL.revokeObjectURL(url)
        } else {
          messageUtil.httpStatusHandler(resp, this)
        }
        this.downloadBatchDocLoading = false
      })
    },

    // async getOpenerList (processId) {
    //   await docFlowApi.getDfDocumentOpenerList(processId, resp => {
    //     if (resp.status === 200 || resp.status === 201) {
    //       this.openerList = resp.data
    //     } else {
    //       messageUtil.httpStatusHandler(resp, this)
    //     }
    //   })
    // },

    async getDFDocumentKey (processId, docCode) {
      let encryptedFileKey = null
      if (this.isMeOpener) {
        await docFlowApi.getDFDocumentKey(processId, docCode, resp => {
          if (resp.status === 200 || resp.status === 201) {
            this.$store.commit(commonComponentModule + '/clearSecurityFileKeys')
            this.$store.commit(commonComponentModule + '/setEncryptedFileKey', resp.data.openerKey)
            this.$store.commit(commonComponentModule + '/setKeyPairId', resp.data.keyPairId)
            encryptedFileKey = resp.data.openerKey
          } else {
            // messageUtil.httpStatusHandler(resp, this)
          }
        })
      }

      return encryptedFileKey
    },

    async getDFDocumentKeyByFlowId (docCode, inflowId, euid, searchType) {
      docFlowApi.getDFDocumentKeyByInflowIdAndSearchingType(docCode, inflowId, euid, searchType, resp => {
        this.loading = false
        // console.log('getDFDocumentKeyByFlowId : ' + JSON.stringify(resp.data))
        if (resp.status === 201 || resp.status === 200) {
          // this.dfDocumentKey = resp.data
          this.$store.commit(commonComponentModule + '/clearSecurityFileKeys')
          this.$store.commit(commonComponentModule + '/setEncryptedFileKey', resp.data.openerKey)
          this.$store.commit(commonComponentModule + '/setKeyPairId', resp.data.keyPairId)

          // console.log('getDFDocumentKeyByFlowId : ')
        }
      })
    },
    previewEDocInternalFileList (items, euid, searchType, openDialog) {
      console.log('previewEDocInternalFileList : ' + euid + JSON.stringify(items))
      let docCode = null // encrypted file
      let dfInflowId = null

      // docFlowApi.getDocumentAttachmentList(processId, resp => {
      // if (resp.status === 201 || resp.status === 200) {
      this.files = []
      // let respData = resp.data
      // respData.sort(getArraySorter('listOrder', true))

      for (let i = 0; i < items.length; i++) {
        let e = items[i]
        let downloadUrl = docFlowApi.downloadDFDocumentByInflowIdUrl + '?docCode=' + e.docCode + '&inflowId=' + e.dfInflowId
        console.log('downloadUrl :' + downloadUrl)
        let pdfInitParams = {
          url: downloadUrl, // docFlowApi.downloadDocumentUrl + '?docCode=' + e.docCode + '&processId=' + processId,
          httpHeaders: { Authorization: 'Bearer ' + this.$g2eOauth.token },
          withCredentials: true,
          CMapReaderFactory
        }
        e.displayName = e.docName.substring(0, e.docName.lastIndexOf('.'))
        e.fileExtension = e.docName.substring(e.docName.lastIndexOf('.') + 1)

        // cannot apply e.docType === DOC_FLOW_FILE_TYPE.OFICIO, always judge as false
        if (e.docType === 'DM') {
          // e.docTypeI18nCode = 'Outbox.Oficio'   // no need to show
          e.docTypeI18nCode = null
        } else if (e.docType === 'DA') {
          console.log('e.fileExtension : ' + e.fileExtension)
          if (e.fileExtension === 'encrypted') {
            docCode = e.docCode
            dfInflowId = e.dfInflowId
          }
          // e.docTypeI18nCode = 'Outbox.Attachment'   // no need to show
          e.docTypeI18nCode = null
        } else if (e.docType === 'PA') {
          e.docTypeI18nCode = 'Outbox.RefDoc'
        }
        // console.log(i + ' || ' + e.displayName + ' ||  ' + e.fileExtension)
        e.url = pdfInitParams
        this.files.push(e)
      }
      if (openDialog) {
        this.dialog = true
      }
      // } else {
      //   messageUtil.httpStatusHandler(resp, this)
      // }

      if (docCode) {
        this.getDFDocumentKeyByFlowId(docCode, dfInflowId, euid, searchType)
      }
      // })
    },

    async downloadEDocBatchDocument (processId) {
      console.log('downloadEDocBatchDocument : ' + JSON.stringify(processId))
      let docList = []
      this.downloadBatchDocLoading = true
      await docFlowApi.getDocumentAttachmentList(processId, resp => {
        docList = resp.data
      })
      docFlowApi.downloadBatchDocument(processId, docList, resp => {
        if (resp.status === 200 || resp.status === 201) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          // let disposition = resp.headers['content-disposition']
          // let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          // link.setAttribute('download', filename)
          link.setAttribute('download', 'document.zip')
          link.click()
          window.URL.revokeObjectURL(url)
        } else {
          messageUtil.httpStatusHandler(resp, this)
        }
        this.downloadBatchDocLoading = false
      })
    },

    async downloadEDocBatchDocumentByDocumentList (documentList) {
      console.log('downloadEDocBatchDocument : ' + JSON.stringify(documentList))
      let docList = []
      this.downloadBatchDocLoading = true
      // await docFlowApi.getDocumentAttachmentList(processId, resp => {
      //  docList = resp.data
      // })
      for (let i = 0; i < documentList.length; i++) {
        docList.push(documentList[i].docCode)
      }

      docFlowApi.downloadBatchDocument(null, docList, resp => {
        if (resp.status === 200 || resp.status === 201) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          // let disposition = resp.headers['content-disposition']
          // let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          // link.setAttribute('download', filename)
          link.setAttribute('download', 'document.zip')
          link.click()
          window.URL.revokeObjectURL(url)
        }
        this.downloadBatchDocLoading = false
      })
    }

    /* updateDetail (index) {
      let record = this.processData.records[index]
      this.isListMode = false
      this.detailPageObj = record

      if (!record.confirmReceivedEuid) {
        docFlowApi.markConfirmReceivedProcess(record.dfProcessId, resp => {
          // No need to show anything
          this.getProcessList()
        })
      }
    }

    isAttentionJob () {
      console.log('check attention: ' + this.taskListJobType === TASK_LIST_JOB_TYPE.ATTENTION_JOB)
      return this.taskListJobType === TASK_LIST_JOB_TYPE.ATTENTION_JOB
    } */

  }
}
